"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getParamValue = exports.RequiredStringValue = exports.Value = void 0;
const ApplicationStore_1 = require("../../stores/ApplicationStore");
class Value {
    getValue() {
        return this.value;
    }
    setValue(value) {
        this.value = value;
        this.touched = true;
    }
}
exports.Value = Value;
class RequiredStringValue extends Value {
    setValue(value) {
        this.isValid = !!value;
        this.value = value;
        this.touched = true;
    }
}
exports.RequiredStringValue = RequiredStringValue;
function getParamValue(context, name) {
    return context.getStore(ApplicationStore_1.default).getParam(name);
}
exports.getParamValue = getParamValue;
